import { render, staticRenderFns } from "./open.vue?vue&type=template&id=fe4afb8c&"
import script from "./open.vue?vue&type=script&lang=ts&"
export * from "./open.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports